import styled from "styled-components";

export const Container = styled.div`
    display: flex;
    justify-content: center;
    padding: 5vh 4vw;
    background-color: #f9f9f9;
    min-height: 100vh;
`;

export const Card = styled.div`
    background-color: #ffffff;
    border-radius: 16px;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);
    padding: 32px 24px;
    width: 100%;
    max-width: clamp(320px, 90vw, 700px);
`;

export const Header = styled.div`
    text-align: center;
    margin-bottom: 32px;
`;

export const LogoWrapper = styled.div`
    margin-bottom: 16px;

    svg {
        max-width: 100%;
        height: auto;
    }
`;

export const OTFormWrapper = styled.div`
    max-width: 100%;
    height: 3000px;
    min-height: 600px;
    border: 1px solid #c0c2c7;
    margin: 32px auto;

    iframe {
        width: 100%;
        height: 100%;
        border: none;
        min-height: 600px;
    }

    @media (max-width: 768px) {
        min-height: 500px;
    }

    @media (max-width: 480px) {
        min-height: 400px;
    }
`;

export const Title = styled.h1`
    font-family: "Source Sans Pro", sans-serif;
    font-size: 24px;
    font-weight: 700;
    color: rgb(138, 5, 56);
    margin-bottom: 8px;

    @media (max-width: 480px) {
        font-size: 20px;
    }
`;

export const DateText = styled.p`
    font-size: 14px;
    color: #666;

    @media (max-width: 480px) {
        font-size: 13px;
    }
`;

export const Section = styled.section`
    margin-bottom: 24px;
`;

export const SectionTitle = styled.h2`
    font-size: 18px;
    font-weight: 600;
    color: rgb(138, 5, 56);
    margin-bottom: 8px;

    @media (max-width: 480px) {
        font-size: 16px;
    }
`;

export const Paragraph = styled.p`
    font-size: 16px;
    color: #404040;
    line-height: 1.6;

    @media (max-width: 480px) {
        font-size: 14px;
    }
`;

export const Button = styled.button`
    margin-top: 32px;
    width: 100%;
    padding: 12px;
    font-size: 16px;
    font-weight: 600;
    background-color: rgb(138, 5, 56);
    color: white;
    border: none;
    border-radius: 8px;
    cursor: pointer;
    transition: background-color 0.3s ease;

    &:hover {
        background-color: #a00445;
    }

    &:focus {
        outline: 2px solid #a00445;
        outline-offset: 2px;
    }

    @media (max-width: 480px) {
        font-size: 15px;
        padding: 10px;
    }
`;
